import Vue from 'vue'
import Router from 'vue-router'

//signup
import signup from '@/components/signup'
//login
import login from '@/components/login'
//thanks
import thanks from '@/components/thanks'
//set Password
import addProfileData from '@/components/addProfileData'
//home
import home from '@/components/home'

Vue.use(Router)

export default new Router({
  mode : 'history',
  routes: [
    { path: '/', name: 'Signup', component: signup },
    { path: '/thanks', name: 'Thanks', component: thanks },
    { path: '/signup', name: 'Signup', component: signup},
    { path: '/profile-setup', name: 'addProfileData', component: addProfileData},
    { path: '/home', name: 'Home', component: home}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js